<div class="d-flex flex-column">
    <div class="body-section__wrapper__box__title">
        <p>{{ 'app.profile.cambiar-nombre-deusuario' | translate }}</p>
    </div>
    <div class="div-disp my-4">
        <form [formGroup]="userNameForm">
            <div class="col-12 col-md-8 pl-0">
                <mc-form-group-input
                    class="control-readonly"
                    [form]="userNameForm"
                    [submitted]="submitted"
                    name="currentUsername"
                    type="text"
                    label="{{ 'app.profile.nombre-de-usuario-actual' | translate }}"
                >
                </mc-form-group-input>
            </div>
            <div class="col-12 col-md-8 pl-0 mt-2">
                <mc-form-group-input
                    [form]="userNameForm"
                    [submitted]="submitted"
                    name="userName"
                    type="text"
                    label="{{ 'app.profile.nuevo-nombre-de-usuario' | translate }}"
                    (input)="changeUserNameInput($event)"
                >
                </mc-form-group-input>
                <span class="username-error" *ngIf="(userNameError$ | async) && userNameForm.valid && showUserError">
                    {{ 'app.profile.validaciones.usuario-existe' | translate }}</span
                >
                <div class="mt-2">
                    <span> {{ 'app.profile.con_este_usuario' | translate }}</span>
                    <!-- <a class="link" href="userUrl" target="_blank">
                        {{ userUrl }}</a> -->
                </div>
            </div>

            <div class="d-flex col-12 pl-0 justify-content-end">
                <button
                    class="btn btn-continue"
                    [disabled]="loadingUserName || !userNameForm.valid || disabledUserButton"
                    (click)="changeUserName()"
                >
                    <mc-loading *ngIf="loadingUserName" color="text-white" size="sm"></mc-loading>
                    {{ 'app.profile.guardar' | translate }}
                </button>
            </div>
        </form>
    </div>
</div>

<div class="d-flex flex-column">
    <div class="body-section__wrapper__box__title">
        <p>{{ 'app.profile.cambiar_contraseña' | translate }}</p>
    </div>
    <div class="div-disp my-4">
        <form [formGroup]="passwordForm">
            <div class="col-12 col-md-8 pl-0">
                <div class="mt-2">
                    <mc-form-group-input
                        [form]="passwordForm"
                        [submitted]="submitted"
                        name="password"
                        type="password"
                        label="{{ 'app.profile.escribe_tu_nueva_contraseña' | translate }}"
                        (input)="changePasswordInput($event)"
                    >
                    </mc-form-group-input>
                </div>
                <div class="mt-2">
                    <mc-form-group-input
                        [form]="passwordForm"
                        [submitted]="submitted"
                        name="password_confirmation"
                        type="password"
                        label="{{ 'app.profile.repite_la_nueva_contraseña' | translate }}"
                        (input)="changePasswordInput($event)"
                    >
                    </mc-form-group-input>
                </div>
                <div class="passwordValidation">
                    <p class="passwordValidation-title">
                        {{ 'app.profile.validaciones.elige_la_cuenta_teniendo_en_cuenta' | translate }}
                    </p>
                    <div class="passwordValidation__groupInput">
                        <i
                            class="passwordValidation__groupInput-icon"
                            [ngClass]="
                                this.password?.value?.length < 8 || !password.value
                                    ? 'fal fa-times-circle'
                                    : 'far fa-check-circle'
                            "
                            [ngStyle]="{ color: this.password?.value?.length < 8 || !password.value ? 'red' : 'green' }"
                        ></i>
                        <p class="passwordValidation__groupInput-text">
                            {{ 'app.profile.validaciones.al_menos_ocho_caracteres' | translate }}
                        </p>
                    </div>
                    <div class="passwordValidation__groupInput">
                        <i
                            class="passwordValidation__groupInput-icon"
                            [ngClass]="
                                password.errors?.validators?.consecutiveNumbers ||
                                password.errors?.validators?.checkNumber ||
                                !password.value
                                    ? 'fal fa-times-circle'
                                    : 'far fa-check-circle'
                            "
                            [ngStyle]="{
                                color:
                                    password.errors?.validators?.consecutiveNumbers ||
                                    password.errors?.validators?.checkNumber ||
                                    !password.value
                                        ? 'red'
                                        : 'green'
                            }"
                        ></i>
                        <p class="passwordValidation__groupInput-text">
                            {{ 'app.profile.validaciones.al_menos_un_numero_no_consecutivo' | translate }}
                        </p>
                    </div>
                    <div class="passwordValidation__groupInput">
                        <i
                            class="passwordValidation__groupInput-icon"
                            [ngClass]="
                                password.errors?.validators?.checkMayus || !password.value
                                    ? 'fal fa-times-circle'
                                    : 'far fa-check-circle'
                            "
                            [ngStyle]="{
                                color: password.errors?.validators?.checkMayus || !password.value ? 'red' : 'green'
                            }"
                        ></i>
                        <p class="passwordValidation__groupInput-text">
                            {{ 'app.profile.validaciones.una_mayus' | translate }}
                        </p>
                    </div>
                    <div class="passwordValidation__groupInput">
                        <i
                            class="passwordValidation__groupInput-icon"
                            [ngClass]="
                                password.errors?.validators?.checkMinus || !password.value
                                    ? 'fal fa-times-circle'
                                    : 'far fa-check-circle'
                            "
                            [ngStyle]="{
                                color: password.errors?.validators?.checkMinus || !password.value ? 'red' : 'green'
                            }"
                        ></i>
                        <p class="passwordValidation__groupInput-text">
                            {{ 'app.profile.validaciones.una_minus' | translate }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="d-flex col-12 pl-0 justify-content-end">
                <button
                    class="btn btn-continue"
                    [disabled]="loadingPassword || !passwordForm.valid || disabledPasswordButton"
                    (click)="onFormSubmit()"
                >
                    <mc-loading *ngIf="loadingPassword" color="text-white" size="sm"></mc-loading>
                    {{ 'app.profile.guardar' | translate }}
                </button>
            </div>
        </form>
    </div>
</div>
